import { useState, useCallback } from "react";
import { parseMissionImageRef } from "utils/missionDocuments";

/**
 * Local state for mission document picker (linked file + pending uploads).
 */
export function useMissionDocuments(initialImage) {
  const [linkedDocument, setLinkedDocument] = useState(() =>
    parseMissionImageRef(initialImage),
  );
  const [pendingFiles, setPendingFiles] = useState([]);

  const addFiles = useCallback((fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    setPendingFiles((prev) => [...prev, ...files]);
  }, []);

  const removePending = useCallback((index) => {
    setPendingFiles((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const removeLinked = useCallback(() => {
    setLinkedDocument(null);
  }, []);

  const clearPending = useCallback(() => {
    setPendingFiles([]);
  }, []);

  const imageForPayload = useCallback(() => {
    if (!linkedDocument?.fileName) return undefined;
    const payload = { fileName: linkedDocument.fileName };
    if (linkedDocument.bucket) payload.bucket = linkedDocument.bucket;
    return payload;
  }, [linkedDocument]);

  return {
    linkedDocument,
    setLinkedDocument,
    pendingFiles,
    addFiles,
    removePending,
    removeLinked,
    clearPending,
    imageForPayload,
  };
}
